import SortLabel from '../../custom-components/SortLabel';
import { SortOptions } from '../../utils/CustomTypes';
import { TableFields } from '../../utils/TableFields';

export function TableRowHeader({
  isAllSortingDisabled = false,
  showSubheader,
  currentSort,
  tableFields,
  onSort
}: {
  isAllSortingDisabled?: boolean,
  showSubheader: boolean,
  currentSort: SortOptions,
  tableFields: TableFields,
  onSort: (sortOptions: SortOptions) => void
}) {
  if (!showSubheader) return <></>
  return <>
    <div className='results-subheader' style={{ justifyContent: 'flex-end', paddingLeft: 45 }}>
      {
        tableFields.getOptions()
          .map((option) => (
            tableFields.isFieldVisible(option.fieldName) &&
              <div key={option.fieldName} style={option.style || {}}>
                <SortLabel
                  fieldName={option.fieldName}
                  isDisabled={isAllSortingDisabled ? true : !tableFields.isFieldSortable(option.fieldName)}
                  currentSort={currentSort}
                  onSort={onSort}
                />
              </div>
          ))
      }
    </div>
  </>
}